// utils/dateUtils.js
function getNewYorkDateTime() {
  const options = {
    timeZone: "America/New_York",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "numeric",
    minute: "2-digit",
    hour12: true
  };

  const formatter = new Intl.DateTimeFormat("en-US", options);
  const formatted = formatter.format(new Date());

  return formatted.replace(", ", " "); 
}

module.exports = { getNewYorkDateTime };
